/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListCourseRemindersParams,
  PaginatedCourseReminders,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Course Reminders
 */
export const listCourseReminders = (
    params?: MaybeRefOrGetter<ListCourseRemindersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedCourseReminders>(
      {url: `/course_reminders`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCourseRemindersQueryKey = (params?: MaybeRefOrGetter<ListCourseRemindersParams>,) => {
    return [
    'course_reminders', ...(params ? [params] : [])
    ] as const;
    }


export const getListCourseRemindersQueryOptions = <TData = Awaited<ReturnType<typeof listCourseReminders>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListCourseRemindersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseReminders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCourseRemindersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCourseReminders>>> = ({ signal }) => listCourseReminders(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCourseReminders>>, TError, TData>
}

export type ListCourseRemindersQueryResult = NonNullable<Awaited<ReturnType<typeof listCourseReminders>>>
export type ListCourseRemindersQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Course Reminders
 */

export function useListCourseReminders<TData = Awaited<ReturnType<typeof listCourseReminders>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListCourseRemindersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCourseReminders>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCourseRemindersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






